module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head_order.cb829b04.svg";